<template>
  <div class="base-wrap" >
    <!--返回标识-->
    <div class="back-icon" >
      <el-breadcrumb separator-class="el-icon-arrow-right ">
        <el-breadcrumb-item :to="{ path: '/index'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/index/index_hotel'}">酒店</el-breadcrumb-item>
        <el-breadcrumb-item>{{ DisplayBasicInfo.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--头部详情-->
    <Introduction :info="DisplayBasicInfo" @photoAlbum="photoAlbumShowControl = true" @Map="MapPositionControl = true" @addQuote="addQuote" @cancelQuote="cancelQuote" @orderConfirm="orderConfirm"></Introduction>
    <!--房间设施导航-->
    <div class="navigation mt-4">
      <div class="nav-item-wrap">
        <div v-for="(item,index) in showNavList" :key="index" class="nav-item" :class="navigationIndex==index?'active':''" @click="project(item.id)">
          {{item.name}}
        </div>
      </div>
      <div class="roomclass" v-if="navigationIndex==0">
      <div v-for="(value,index) in filteredRoomList" :key="index" :class="{'tive':roomclassIndex==index}" @click="roomclassswitch(index,value.data)">
        {{ value.name }}({{ value.data.length }})
      </div>
      </div>
    </div>
    <!--房间详情-->
    <room :room_arr="DisplayBasicInfo.room_arr" @roomDetails="roomDetailswitch" id="room"></room>
    <!--会议详情-->
    <Meeting :meeting_arr="DisplayBasicInfo.meeting_arr" @meetingDetails="MeetingDetailswitch" id="meeting" v-if="DisplayBasicInfo.meetingNum>0"></Meeting>
    <!--酒店设施与服务-->
    <Facility :info="DisplayBasicInfo" class="mb-4" id="facility" ></Facility>
    <!--
    --酒店弹出框信息
    -->
      <!--酒店图片集弹框-->
      <el-dialog
        class="dialog-wrap"
        title="酒店相册"
        @close="onclose"
        :visible.sync="photoAlbumShowControl" width="1540px" 
        >
        <photoAlbum ref="childRef" :photo_album="DisplayBasicInfo.photoAlbum" :info="DisplayBasicInfo" @bookHotel="bookHotel"></photoAlbum>
      </el-dialog>
      <!--酒店地图弹框-->
      <el-dialog
        class="dialog-wrap map-wrap"
        :visible.sync="MapPositionControl" width="70%" >
        <Map :info="DisplayBasicInfo" @bookHotel="bookHotel"></Map>
      </el-dialog>
      <!--酒店简介-->
      <el-dialog
          class="dialog-wrap map-wrap"
          :visible.sync="starControl" width="800px" top="18%" >
          <star :info="DisplayBasicInfo"></star>
      </el-dialog>
      <!--酒店房间详情-->
      <el-dialog
        class="dialog-wrap"
        title="房间详情"
        :visible.sync="roomDetailsControl" width="70%">
          <RoomDetails :info="roomInfo"  @bookHotel="bookHotel"></RoomDetails>
      </el-dialog>
      <!--酒店会议室详情-->
      <el-dialog
        class="dialog-wrap"
        title="会议室详情"
        :visible.sync="MeetingDetailsControl" width="70%" >
          <MeetingDetails :info="MeetingInfo"  @bookHotel="bookHotel"></MeetingDetails>
      </el-dialog>
  </div>
</template>

<script>
import {mapActions,mapState,mapGetters,mapMutations} from 'vuex'
import Introduction from './Components/Introduction.vue'
import Room from './Components/Room.vue'
import RoomDetails from './Components/RoomDetails.vue'
import Meeting from './Components/Meeting.vue'
import MeetingDetails from './Components/MeetingDetails.vue'
import photoAlbum from './Components/photoAlbum.vue'
import Map from './Components/Map.vue'
import Facility from './Components/Facility.vue'
import Star from './Components/Star.vue'
export default {
  name: 'HotelDetails',
  components: {Introduction,Room,RoomDetails,Meeting,photoAlbum,Map,Facility,Star,MeetingDetails},
  props: {},
  data() {
    return {
      navigation:[
        {name:'房间',id:1},
        {name:'会议室',id:2},
        {name:'服务及设施',id:3},
        {name:'周边交通',id:4},
        {name:'酒店简介',id:5}
      ],
      roomclass:[
        {name:'全部',type:0,data:[]},
        {name:'单床房',type:1,data:[]},
        {name:'双床房',type:2,data:[]},
        {name:'三床房',type:3,data:[]},
        {name:'多床房',type:4,data:[]},
      ],
      roomclassIndex:0,
      navigationIndex:0,
      photoAlbumShowControl:false,
      MapPositionControl:false,
      facilitycontrol:false,
      FacilityControl:false,
      starControl:false,
      roomDetailsControl:false,
      roomInfo:{},
      MeetingInfo:{},
      MeetingDetailsControl:false,
      dataList:[{key:'room',id:'0'},{key:'meeting',id:'1'},{key:'facility',id:'2'}],
      groupPositions: {}, // 记录每个分组的位置信息
      // 滚动动画持续时间(毫秒)
      duration:500,
      isScrolling: false // 是否正在执行滚动动画
    };
  },
  computed: {

    ...mapState(['DisplayBasicInfo']),
    ...mapGetters(['userInfo']),
    paramsId() {
        return this.$route.params.id;
    },
      // 过滤出 data 有内容的项
    filteredRoomList() {
      return this.roomclass.filter(item => {
        // 你原来的判断条件：只保留 data.length > 0 的项
        return item.data && item.data.length > 0
      })
    },
    showNavList() {
      const { meetingNum } = this.DisplayBasicInfo
      
      // 满足条件：从第2项开始（去掉第一项）
      if (meetingNum <= 0) {
        return this.navigation.slice(1) 
      }
      
      // 不满足：返回全部
      return this.navigation
    }
  },
  watch: {
  },
  created() {
     this.GetHotelDetails()
  },
  updated() {
    this.calculatePositions(); // 计算每个分组的位置信息
  },
  mounted() {
    // 绑定滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations(['UPDATEINQUIRYLISTINFO','UPDATECONFIRMINFO']),
    ...mapActions(['GetDisplayInfo']),
    //关相册的回调
    onclose(){
      this.$refs.childRef.childMethod(); // 通过ref直接调用
    },
    // 计算每个分组的位置信息
    calculatePositions() {
      this.groupPositions = {};
      this.dataList.forEach(group => {
        const element = document.getElementById(`${group.key}`);
        if (element) {
          this.groupPositions[group.key] = element.offsetTop;
        }
      });
    },
    // 处理列表滚动，更新当前激活的索引
    handleScroll() {
      if (this.isScrolling) return; // 触摸时不更新
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const keys = [...this.dataList].reverse(); // 倒序检查
      for (const i of keys) {
        const position = this.groupPositions[i.key];
        if (scrollTop >= position -150) { // 留出一点误差空间
          this.navigationIndex = i.id;
          break;
        }
      }
    },
    //获取酒店详情
    GetHotelDetails(){
        this.GetDisplayInfo({
            type:'3',
            data: {
              store_id: this.paramsId,
            },
            successFun:(e) => {
              // 处理房间类型
              e.room_arr.forEach(item => {
                  this.roomclass.forEach(v => {
                    if(v.type === item.type){
                      v.data.push(item)
                    }
                  })
              })
              this.roomclass[0].data = e.room_arr;
              console.log(this.roomclass);
            }
        }).then(()=>{
            this.setTitle(this.DisplayBasicInfo.title)
        })
    },
    //网站标题
    setTitle(str){
        document.title = `${str}-订单雨`
    },
    //点击设计切换
    project(id){
      switch (id) {
          case 1:
            this.scrollTo('room')
            // let room = document.getElementById('room');
            //   room.scrollIntoView({
            //     behavior: 'smooth', // 滚动动画：smooth（平滑）/ auto（瞬间）
            //     block: 'start',    // 垂直对齐方式：start（顶部对齐）/ center（居中）/ end（底部对齐）
            //     inline: 'nearest'  // 水平对齐方式（默认无需修改）
            //   });
            this.navigationIndex=0;
            break;
          case 2:
            this.scrollTo('meeting')
            // let meeting = document.getElementById('meeting');
            //   meeting.scrollIntoView({
            //     behavior: 'smooth', 
            //     block: 'start',    
            //     inline: 'nearest'  
            // });
            this.navigationIndex=1;
          break;
          case 3:
            this.scrollTo('facility')
            // let facility = document.getElementById('facility');
            //   facility.scrollIntoView({
            //     behavior: 'smooth', 
            //     block: 'start',    
            //     inline: 'nearest'  
            // });
            this.navigationIndex=2;
            break;
          case 4:
            this.MapPositionControl = true;
            break;
          case 5:
            this.starControl=true;
            break;
          default:
            break;
      }
    },
    
    // 平滑滚动到指定索引位置
    scrollTo(key) {
      console.log(key);
      const targetPosition = this.groupPositions[key]-150;
      if (targetPosition === undefined || this.isScrolling) return;
      this.isScrolling = true;
      this.currentKey = key;
      const startPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const distance = targetPosition - startPosition;
      const startTime = performance.now();
      // 执行滚动动画
      const animateScroll = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        // 如果动画未完成
        if (elapsedTime < this.duration) {
          // 根据选择的缓动函数计算当前位置
          let progress;
          switch ('easeOutQuad') {
            case 'linear':
              progress = elapsedTime / this.duration;
              break;
            case 'easeOutQuad':
              progress = 1 - (1 - elapsedTime / this.duration) * (1 - elapsedTime / this.duration);
              break;
            case 'easeInOutQuad':
              progress = elapsedTime / (this.duration / 2) < 1 
                ? 0.5 * Math.pow(elapsedTime / (this.duration / 2), 2)
                : 1 - 0.5 * Math.pow(2 - elapsedTime / (this.duration / 2), 2);
              break;
            default:
              progress = elapsedTime / this.duration;
          }
          document.documentElement.scrollTop = startPosition + distance * progress;
          requestAnimationFrame(animateScroll);
        } else {
          // 动画完成，确保精确到达目标位置
          document.documentElement.scrollTop = targetPosition;
          this.isScrolling = false;
        }
      }
      // 开始动画
      requestAnimationFrame(animateScroll);
    },
    //点击房间详情弹窗
    roomDetailswitch(e){
      this.roomInfo=e;
      this.roomDetailsControl=true;
    },
    //点击会议室详情弹窗
    MeetingDetailswitch(e){
      this.MeetingInfo=e;
      this.MeetingDetailsControl=true;
    },
    //点击房型分类
    roomclassswitch(index,data){
      this.roomclassIndex=index;
      this.DisplayBasicInfo.room_arr=data;
    },
    //预订酒店
    bookHotel(item='room') {
      let text=item==='meet'?'纯会议订单(不住宿)':'住宿订单'
      // if (!this.$GFUN.powerIsInArray([226])) { this._alert('您没有相关权限！',null,'error'); return; }
      if(!this.userInfo.type){
      this.$alert('请先登录账号，再预订该酒店', '提示', {
          confirmButtonText: '确定',
          center: true,
          callback: () => {
            this.$router.push('/userLogin');
          }
        });
        return
      };
      if (this.userInfo.type !== 2)
        this.$alert('您不是采购商用户，无法预订该酒店', '提示', {
          confirmButtonText: '确定',
          center: true
        });
      else this.PostRoomOrder(null,text);
    },
    //加入询价清单
    addQuote(){
      this.UPDATEINQUIRYLISTINFO({infoList:this.DisplayBasicInfo,modify:'add'});
      this.$message.success('添加成功！');
    },
    //取消询价清单
    cancelQuote(){
      this.UPDATEINQUIRYLISTINFO({infoList:this.DisplayBasicInfo,modify:'deletes'});
      this.$message.success('取消成功！');
    },
    //发布确认订单
    orderConfirm(){
      this.UPDATECONFIRMINFO(this.paramsId);
      let query = {orderConfirm:true,modify:true,orderConfirmSend:true}
      this.$router.push({name:'OrderPost',query})
    },
      /*点击单个日期或房型/会议室发布定向订单*/
    PostRoomOrder(timestamp, postName) {
      let queryData = {
        type: postName,
        hotel: this.paramsId,
        hotelName: this.DisplayBasicInfo.title,
        province: this.DisplayBasicInfo.province,
        provinceName: this.DisplayBasicInfo.provinceName,
        city: this.DisplayBasicInfo.city,
        cityName: this.DisplayBasicInfo.cityName,
        district: this.DisplayBasicInfo.district,
        districtName: this.DisplayBasicInfo.districtName,
        star: this.DisplayBasicInfo.star,
        checkinDate: timestamp
      };
      this.$router.push({name: 'OrderPost', query: queryData});
    },
  }
};
</script>

<style lang="scss" scoped>

.back-icon{
    text-align: left;
    padding: 20px 0;
}
.navigation{
  width: 96%;
  background-color: #fff;
  padding: 12px 2%;
  border-radius: 6px;
  position: sticky;
  top: 80px;
  border-bottom: 1px #f5f7fa solid;
  z-index: 2;
  .nav-item-wrap{
    display: flex;
    border-bottom: 1px #eee solid;
  }
  div{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-right: 40px;
    padding: 6px 0;
    position: relative;
    cursor: pointer;
  }
  .active{
    border-bottom: 2px solid var(--smtc-color-primary);
  }
}
.wraps{
  background-color: #d1e1ef;
}
#room,#meeting,#facility{
   scroll-margin-top: 150px;
}
.roomclass{
  text-align: left;
  display: flex;
  margin-top: 10px;
  div{
    font-weight: normal;
    font-size: 14px;
    background-color: #f5f7fa;
    padding: 6px 15px;
    margin-right: 16px;
    border-radius: 4px;
  }
  .tive{
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
}
</style>
<style>
  .dialog-wrap .el-dialog__body{
    padding: 0 ;
  }
  .map-wrap .el-dialog{
    border-radius: 6px;
    overflow: hidden;
  }
  .map-wrap .el-dialog__header{
    padding: 0;
    margin-bottom: 0;
  }
  .dialog-wrap  .el-dialog__headerbtn .el-dialog__close{
    color: #999;
    font-size: 20px;
  }
</style>
